module.exports = __webpack_public_path__ + "img/House Pin.ebd774bb.svg";